document.addEventListener("DOMContentLoaded", () => {

    const overlay = document.getElementById("ob-gift-overlay");

    if (!overlay) return;

    /* -----------------------------------
       Show only once per session
    ----------------------------------- */

    if (sessionStorage.getItem("obGiftSeen") === "true") {
        return;
    }

    setTimeout(() => {

        overlay.classList.add("active");

    }, 800);

    sessionStorage.setItem("obGiftSeen", "true");

    /* -----------------------------------
       Elements
    ----------------------------------- */

    const stepOne = overlay.querySelector(".ob-step-one");
    const stepTwo = overlay.querySelector(".ob-step-two");

    const openGift = overlay.querySelector(".ob-open-gift");
    const continueBtn = overlay.querySelector(".ob-continue");
    const closeBtn = overlay.querySelector(".ob-popup-close");

    /* -----------------------------------
       Open Gift
    ----------------------------------- */

    openGift.addEventListener("click", () => {

        stepOne.classList.add("hide");

        stepTwo.classList.add("active");

    });

    /* -----------------------------------
       Close Popup
    ----------------------------------- */

    function closePopup(){

        overlay.classList.remove("active");

    }

    continueBtn.addEventListener("click", closePopup);

    closeBtn.addEventListener("click", closePopup);

    /* -----------------------------------
       Click outside
    ----------------------------------- */

    overlay.addEventListener("click",(e)=>{

        if(e.target===overlay){

            closePopup();

        }

    });

    /* -----------------------------------
       ESC key
    ----------------------------------- */

    document.addEventListener("keydown",(e)=>{

        if(e.key==="Escape"){

            closePopup();

        }

    });

});